import { takeEvery, put, call } from "redux-saga/effects";

import {
  getSubscriptionsAPI,
  getSubscriptionAPI,
  updateSubscriptionAPI,
} from "../../../helpers/backend.helper";
import {
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION,
} from "./actionTypes";
import {
  getSubscriptionError,
  getSubscriptionsError,
  getSubscriptionsSuccess,
  getSubscriptionSuccess,
  updateSubscriptionError,
  updateSubscriptionSuccess,
} from "./actions";

function* getSubscriptions({ payload: { request } }) {
  try {
    const response = yield call(getSubscriptionsAPI, request);
    if (response) {
      yield put(getSubscriptionsSuccess(response?.data));
    }
  } catch (error) {
    yield put(getSubscriptionsError(error));
  }
}

function* getSubscription({ payload: { id } }) {
  try {
    const response = yield call(getSubscriptionAPI, id);
    if (response) {
      yield put(getSubscriptionSuccess(response?.data));
    }
  } catch (error) {
    yield put(getSubscriptionError(error));
  }
}

function* updateSubscription({ payload: { request } }) {
  try {
    const response = yield call(updateSubscriptionAPI, request);
    if (response) {
      yield put(updateSubscriptionSuccess());
    }
  } catch (error) {
    yield put(updateSubscriptionError(error));
  }
}

function* subscriptionsSaga() {
  yield takeEvery(GET_SUBSCRIPTIONS, getSubscriptions);
  yield takeEvery(GET_SUBSCRIPTION, getSubscription);
  yield takeEvery(UPDATE_SUBSCRIPTION, updateSubscription);
}

export default subscriptionsSaga;
